<template>

    <div class="generator">
        <HeaderUI/>
        <main class="page-main">
            <div class="page-container">

                <div class="page-header">
                    <div>
                        <h1 class="page-title">Генератор актов</h1>
                        <p class="page-description">Заполните данные и сформируйте Word-акт приёма-передачи ТМЦ</p>
                    </div>
                </div>

                <div class="gen-layout">

                    <div class="gen-main">

                        <section class="card">
                            <div class="card-header work-card-header">
                                <div class="card-title">
                                    <AppIcon name="generator" class="card-title-icon"/>
                                    Рабочая область
                                </div>
                                <div class="work-card-header-actions">
                                    <button type="button" class="icon-btn" title="Черновики" @click="openDrafts()">
                                        <AppIcon name="folder" class="icon-btn-icon"/>
                                        <span class="icon-btn-count" v-if="drafts.length > 0">{{ drafts.length }}</span>
                                    </button>
                                    <button type="button" class="icon-btn" title="Сохранить как черновик" @click="openSaveDraft()">
                                        <AppIcon name="save" class="icon-btn-icon"/>
                                    </button>
                                    <button type="button" class="icon-btn" title="Новый акт" @click="resetForm()">
                                        <AppIcon name="add" class="icon-btn-icon"/>
                                    </button>
                                </div>
                            </div>
                            <div class="card-body">

                                <div class="grid-2 grid-2--form">
                                    <InputUI @myData="send_post = $event" :title="'Должность сдающего'" :icon="'user'" :myval="send_post"/>
                                    <InputUI @myData="send_fio = $event" :title="'ФИО сдающего'" :icon="'user'" :myval="send_fio"/>
                                    <InputUI @myData="accept_post = $event" :title="'Должность принимающего'" :icon="'user'" :myval="accept_post"/>
                                    <InputUI @myData="accept_fio = $event" :title="'ФИО принимающего'" :icon="'user'" :myval="accept_fio"/>
                                </div>

                                <div class="params-row">
                                    <div class="select-block">
                                        <label class="select-label">
                                            <AppIcon name="package" class="select-label-icon"/>
                                            <span>Тип ТМЦ</span>
                                        </label>
                                        <select v-model="tmc_type" class="select-input">
                                            <option value="0" disabled>Выберите тип</option>
                                            <option value="1">ТМЦ</option>
                                            <option value="2">Телефония</option>
                                        </select>
                                    </div>
                                    <div class="toggles">
                                        <ToggleSwitch @myData="isDate = $event" :title="'Убрать даты'" :icon="'clock'" :checked="isDate"/>
                                        <ToggleSwitch @myData="isKyrch = $event" :title="'Надпись внизу акта'" :icon="'pin'" :checked="isKyrch"/>
                                    </div>
                                </div>

                                <InputUI class="kurch-input" v-if="kurch_visible" @myData="kurch_text = $event" :title="'Текст надписи'" :icon="'pin'" :placeholder="'Курчатов'" :min_width="100" :myval="kurch_text"/>
                                <p class="field-hint" v-if="kurch_visible">Надпись будет размещена под актом.</p>

                                <div class="banner banner--info" v-if="kurch_prints">
                                    <AppIcon name="pin" class="banner-icon"/>
                                    <span class="banner-text">Внизу акта будет напечатано: «{{ effective_kurch_text }}»</span>
                                </div>

                                <div class="add-row">
                                    <InputUI @myData="tmc_name = $event" :title="'Наименование ТМЦ'" :icon="'package'" :min_width="200" :myval="tmc_name"/>
                                    <InputUI @myData="tmc_inv = $event" :title="tmc_type == 1 ? 'Инвентарный номер' : 'Мак адрес'" :icon="'hash'" :min_width="200" :myval="tmc_inv"/>
                                    <InputUI @myData="tmc_serial = $event" :title="'Серийный номер'" :icon="'doc'" :min_width="200" :myval="tmc_serial"/>
                                    <ButtonUI :title="'Добавить'" :icon="'add'" @click="additem()"/>
                                </div>

                                <section v-if="items.length === 0" class="empty">
                                    Позиции пока не добавлены - заполните поля выше и нажмите «Добавить»
                                </section>

                                <div v-else class="table-scroll table-scroll--items">
                                    <table class="table">
                                        <thead>
                                            <tr>
                                                <th class="th-num">№</th>
                                                <th>Наименование ТМЦ</th>
                                                <th>{{ tmc_type == 1 ? 'Инвентарный номер' : 'Мак адрес' }}</th>
                                                <th>Серийный номер</th>
                                                <th>Ед. изм.</th>
                                                <th>Кол-во</th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(item, index) in items" :key="index">
                                                <td class="td-num">{{ index + 1 }}</td>
                                                <td>
                                                    <textarea :ref="index + 1 + '_item_name'" class="item_input" v-model="items[index].name"></textarea>
                                                </td>
                                                <td>
                                                    <input type="text" :id="index + 1 + '_item_inv'" class="item_input" v-model="items[index].inv" onfocus="this.select()"/>
                                                </td>
                                                <td>
                                                    <div class="serial-row" v-for="(item, indexs) in items[index].serial" :key="indexs">
                                                        <input type="text" :id="index + 1 + '_item_serial'" class="item_input" v-model="items[index].serial[indexs]" onfocus="this.select()"/>
                                                        <button type="button" class="row-btn" title="Добавить серийный номер" @click="addSerial(index)">
                                                            <AppIcon name="add" class="row-btn-icon"/>
                                                        </button>
                                                        <button type="button" class="row-btn row-btn--danger" title="Удалить серийный номер" @click="removeSerial(index, indexs)">
                                                            <AppIcon name="remove" class="row-btn-icon"/>
                                                        </button>
                                                    </div>
                                                </td>
                                                <td>
                                                    <select class="item_input" v-model="items[index].count_type">
                                                        <option value="шт">шт</option>
                                                        <option value="компл">компл</option>
                                                    </select>
                                                </td>
                                                <td>
                                                    <input type="number" min="1" class="item_input item_input--num" v-model="items[index].count"/>
                                                </td>
                                                <td>
                                                    <button type="button" class="row-btn row-btn--danger" title="Удалить позицию" @click="removeItem(index)">
                                                        <AppIcon name="trash" class="row-btn-icon"/>
                                                    </button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>

                            </div>
                            <div class="card-footer gen-actions">
                                <div class="gen-actions-left">
                                    <span class="gen-meta">
                                        <AppIcon name="package" class="gen-meta-icon"/>
                                        Позиций: {{ items.length }}
                                    </span>
                                </div>
                                <div class="gen-actions-right">
                                    <ButtonUI v-if="is_download" :title="'Скачать DOC'" :icon="'download'" variant="outline" @click="download()"/>
                                    <ButtonUI :title="generating ? 'Генерация...' : 'Сгенерировать DOC'" :icon="'gear'" :disabled="generating" @click="generate()"/>
                                </div>
                            </div>
                        </section>

                        <section class="card history-card">
                            <div class="card-header work-card-header">
                                <div class="card-title">
                                    <AppIcon name="clock" class="card-title-icon"/>
                                    Моя история генераций
                                    <span class="badge badge--soft" v-if="history_total > 0">{{ history_total }}</span>
                                </div>
                            </div>
                            <div class="card-body">

                                <div v-if="history_loading" class="empty">Загрузка...</div>

                                <div v-else-if="history.length === 0" class="empty">
                                    Здесь появятся только ваши сгенерированные акты
                                </div>

                                <template v-else>
                                    <div class="table-scroll">
                                        <table class="table">
                                            <thead>
                                                <tr>
                                                    <th>Дата</th>
                                                    <th>Тип</th>
                                                    <th>Принял</th>
                                                    <th>Позиций</th>
                                                    <th></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="record in history" :key="record.id">
                                                    <td class="td-muted">{{ format_date(record.created_at) }}</td>
                                                    <td>
                                                        <span class="badge" :class="record.tmc_type == '2' ? 'badge--phone' : 'badge--outline'">{{ record.tmc_type == '2' ? 'Телефония' : 'ТМЦ' }}</span>
                                                    </td>
                                                    <td>{{ record.accept_user }}</td>
                                                    <td class="td-muted">{{ record.items ? record.items.length : 0 }}</td>
                                                    <td>
                                                        <div class="row-actions">
                                                            <button type="button" class="row-btn" title="Повторить данные в форме" @click="restoreHistory(record)">
                                                                <AppIcon name="restore" class="row-btn-icon"/>
                                                            </button>
                                                            <button type="button" class="row-btn" title="Скачать DOC" @click="downloadHistory(record)">
                                                                <AppIcon name="download" class="row-btn-icon"/>
                                                            </button>
                                                            <button type="button" class="row-btn" title="Предпросмотр DOC" @click="previewHistory(record)">
                                                                <AppIcon name="eye" class="row-btn-icon"/>
                                                            </button>
                                                            <button type="button" class="row-btn row-btn--danger" title="Удалить из истории" @click="deleteHistory(record)">
                                                                <AppIcon name="trash" class="row-btn-icon"/>
                                                            </button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>

                                    <div class="history-footer">
                                        <PaginationUI :page="history_page" :pages="history_pages" @change="onHistoryPage"/>
                                    </div>
                                </template>

                            </div>
                        </section>

                    </div>

                </div>

            </div>
        </main>

        <ModalUI :open="drafts_modal" @close="drafts_modal = false" :title="'Черновики'" :icon="'folder'">
            <div v-if="drafts.length === 0" class="empty">Черновиков пока нет</div>
            <div v-else class="side-list side-list--modal">
                <div class="side-item" v-for="draft in drafts" :key="draft.id">
                    <AppIcon name="doc" class="side-item-icon"/>
                    <div class="side-item-body">
                        <div class="side-item-title">{{ draft.name }}</div>
                        <div class="side-item-sub">{{ draft_items_count(draft) }} поз. · {{ format_date(draft.updated_at || draft.created_at) }}</div>
                    </div>
                    <div class="side-item-actions">
                        <button type="button" class="row-btn" title="Загрузить" @click="loadDraft(draft)">
                            <AppIcon name="restore" class="row-btn-icon"/>
                        </button>
                        <button type="button" class="row-btn row-btn--danger" title="Удалить" @click="deleteDraft(draft)">
                            <AppIcon name="trash" class="row-btn-icon"/>
                        </button>
                    </div>
                </div>
            </div>
        </ModalUI>

        <ModalUI :open="save_modal" @close="save_modal = false" :title="'Сохранить черновик'" :icon="'save'" :width="420">
            <div class="draft-name-row">
                <InputUI @myData="draft_name = $event" :title="'Название черновика'" :icon="'doc'" :min_width="100" :myval="draft_name"/>
            </div>
            <p class="modal-hint">Черновик сохранит стороны акта, параметры и список позиций. Виден только вам.</p>
            <div class="gen-actions-right draft-modal-actions">
                <ButtonUI :title="'Отмена'" variant="ghost" @click="save_modal = false"/>
                <ButtonUI :title="'Сохранить'" :icon="'save'" :disabled="draft_saving" @click="saveDraftToServer()"/>
            </div>
        </ModalUI>

        <ModalUI :open="preview_modal" @close="closePreview()" :title="'Предпросмотр акта'" :icon="'eye'" :width="860">
            <div v-if="preview_loading" class="empty">Загрузка...</div>

            <div v-else-if="!preview_url" class="empty">Не удалось загрузить файл предпросмотра</div>

            <iframe v-else class="preview-frame" :src="preview_url" title="Предпросмотр акта"></iframe>
        </ModalUI>

    </div>

</template>


<script>

import HeaderUI from '../components/HeaderUI.vue'
import InputUI from '../components/InputUI.vue'
import ToggleSwitch from '../components/ToggleSwitch.vue'
import ButtonUI from '@/components/ButtonUI.vue'
import ModalUI from '@/components/ModalUI.vue'
import PaginationUI from '@/components/PaginationUI.vue'
import AppIcon from '@/components/AppIcon.vue'

import { storage } from '@/services/storage'

import axios from 'axios'

const API_URL = '/api/v1'

export default {
    name: 'GeneratorView',

    components: {
        HeaderUI,
        InputUI,
        ToggleSwitch,
        ButtonUI,
        ModalUI,
        PaginationUI,
        AppIcon
    },

    created() {
        this.loadLocalDraft();
        this.loadDrafts();
        this.loadHistory();
    },

    data() {
        return {
            send_post: null,
            send_fio: null,
            accept_post: null,
            accept_fio: null,
            items: [],
            is_download: false,
            isDate: false,
            isKyrch: false,
            kurch_text: 'Курчатов',
            tmc_type: 1,
            tmc_name: null,
            tmc_inv: null,
            tmc_serial: null,
            generating: false,

            drafts: [],
            drafts_loading: false,
            drafts_modal: false,
            save_modal: false,
            draft_name: '',
            draft_saving: false,
            editing_draft_id: null,

            preview_modal: false,
            preview_loading: false,
            preview_url: null,

            history: [],
            history_loading: false,
            history_page: 1,
            history_pages: 1,
            history_total: 0
        }
    },

    computed: {
        kurch_visible() {
            return this.isKyrch;
        },

        kurch_prints() {
            return this.isKyrch;
        },

        effective_kurch_text() {
            return this.kurch_text || 'Курчатов';
        }
    },

    methods: {
        authParams() {
            return {
                token: localStorage.getItem('token') || ''
            };
        },

        collectData() {
            return {
                send_user: this.send_fio || '',
                send_post: this.send_post || '',
                accept_user: this.accept_fio || '',
                accept_post: this.accept_post || '',
                items: JSON.parse(JSON.stringify(this.items)),
                tmc_type: String(this.tmc_type),
                is_date: this.isDate == true,
                is_kurch: this.isKyrch == true,
                kurch_text: this.kurch_text || ''
            };
        },

        applyData(data) {
            this.send_post = data.send_post || null;
            this.send_fio = data.send_user || null;
            this.accept_post = data.accept_post || null;
            this.accept_fio = data.accept_user || null;
            this.items = Array.isArray(data.items) ? JSON.parse(JSON.stringify(data.items)) : [];
            this.isDate = data.is_date == true;
            this.isKyrch = data.is_kurch == true;
            this.kurch_text = data.kurch_text || 'Курчатов';
            this.tmc_type = data.tmc_type !== undefined && data.tmc_type !== null && data.tmc_type !== '' ? data.tmc_type : 1;
        },

        resetForm() {
            this.send_post = null;
            this.send_fio = null;
            this.accept_post = null;
            this.accept_fio = null;
            this.items = [];
            this.is_download = false;
            this.isDate = false;
            this.isKyrch = false;
            this.kurch_text = 'Курчатов';
            this.tmc_type = 1;
            this.tmc_name = null;
            this.tmc_inv = null;
            this.tmc_serial = null;
            this.editing_draft_id = null;
        },


        loadLocalDraft() {
            const draft = storage.get('draft');

            if (draft !== null) {
                this.applyData(draft);
                return;
            }

            const l_items = localStorage.getItem('l_items');

            if (l_items !== null) {
                this.applyData({
                    send_post: localStorage.getItem('l_send_post'),
                    send_user: localStorage.getItem('l_send_fio'),
                    accept_post: localStorage.getItem('l_accept_post'),
                    accept_user: localStorage.getItem('l_accept_fio'),
                    items: JSON.parse(l_items),
                    is_date: localStorage.getItem('l_isDate') == 'true',
                    is_kurch: localStorage.getItem('l_isKyrch') == 'true',
                    tmc_type: localStorage.getItem('l_tmc_type') || 1
                });
            }
        },

        draft_items_count(draft) {
            const data = draft.data || {};

            return Array.isArray(data.items) ? data.items.length : 0;
        },

        loadDrafts() {
            this.drafts_loading = true;

            axios.get(API_URL + '/drafts', { params: this.authParams() }).then((response) => {
                this.drafts = response.data;
            }).catch((error) => {
                console.log(error);
            }).finally(() => {
                this.drafts_loading = false;
            });
        },

        openDrafts() {
            this.drafts_modal = true;
            this.loadDrafts();
        },

        openSaveDraft() {
            if (localStorage.getItem('token') === null) {
                return alert('Черновики доступны только авторизованным пользователям');
            }

            const existing = this.editing_draft_id !== null
                ? this.drafts.find((d) => d.id === this.editing_draft_id)
                : null;

            this.draft_name = existing ? existing.name : '';
            this.save_modal = true;
        },

        saveDraftToServer() {
            const name = (this.draft_name || '').trim() || ('Черновик от ' + this.short_date(Date.now() / 1000));

            this.draft_saving = true;

            const payload = {
                name: name,
                data: this.collectData()
            };

            let request;

            if (this.editing_draft_id !== null) {
                request = axios.put(API_URL + '/drafts/' + this.editing_draft_id, payload, { params: this.authParams() });
            } else {
                request = axios.post(API_URL + '/drafts', payload, { params: this.authParams() });
            }

            request.then(() => {
                this.save_modal = false;
                this.loadDrafts();
            }).catch((error) => {
                console.log(error);
                alert('Не удалось сохранить черновик');
            }).finally(() => {
                this.draft_saving = false;
            });
        },

        loadDraft(draft) {
            this.applyData(draft.data || {});
            this.editing_draft_id = draft.id;
            this.drafts_modal = false;
        },

        deleteDraft(draft) {
            if (!confirm('Удалить черновик «' + draft.name + '»?')) {
                return;
            }

            axios.delete(API_URL + '/drafts/' + draft.id, { params: this.authParams() }).then(() => {
                if (this.editing_draft_id === draft.id) {
                    this.editing_draft_id = null;
                }

                this.loadDrafts();
            }).catch((error) => {
                console.log(error);
            });
        },


        additem(){
            this.items.push({
                name: this.tmc_name,
                inv: this.tmc_inv,
                serial: [this.tmc_serial],
                count: 1
            });
        },

        removeItem(index){
            this.items.splice(index, 1);
        },

        addSerial(index){
            this.items[index].serial.push('');
        },

        removeSerial(index, indexs){
            if (this.items[index].serial.length > 1){
                this.items[index].serial.splice(indexs, 1);
            } else {
                alert("Нельзя удалить последнее поле");
            }
        },

        generate(){
            if(localStorage.getItem('user_id') == null){
                return alert("Вы не авторизованы");
            }

            if(this.generating){
                return;
            }

            this.is_download = false;
            this.generating = true;

            const data = this.collectData();

            const params = new URLSearchParams();
            params.set("send_user", data.send_user);
            params.set("send_post", data.send_post);
            params.set("accept_user", data.accept_user);
            params.set("accept_post", data.accept_post);
            params.set("tmc_type", data.tmc_type);
            params.set("user_id", String(localStorage.getItem('user_id')));
            params.set("token", localStorage.getItem('token') || "");
            params.set("isDate", data.is_date);
            params.set("isKurch", data.is_kurch);
            params.set("kurch_text", data.kurch_text || "Курчатов");

            axios.post(API_URL + "/generator/generate?" + params.toString(),
                data.items,
                {
                    headers:{
                        accept: 'application/json',
                        'Content-Type': 'application/json'
                    },
                }
            ).then((responce) => {
                storage.set('file_name', responce.data["file_name"]);
                this.is_download = true;
                this.loadHistory();
            }).catch((error) => {
                console.log(error);
            }).finally(() => {
                this.generating = false;
            })
        },

        download(){
            window.location.href = API_URL + "/generator/download?file_name=" + storage.get('file_name');
        },

        loadHistory(){
            this.history_loading = true;

            axios.get(API_URL + "/history/paged", {
                params: {
                    user_id: localStorage.getItem('user_id'),
                    page: this.history_page,
                    page_size: 8
                }
            }).then((response) => {
                this.history = response.data.items;
                this.history_pages = response.data.pages;
                this.history_total = response.data.total;
            }).catch((error) => {
                console.log(error);
            }).finally(() => {
                this.history_loading = false;
            })
        },

        onHistoryPage(page){
            this.history_page = page;
            this.loadHistory();
        },

        format_date(timestamp){
            const d = new Date(timestamp * 1000);

            const pad = (num) => String(num).padStart(2, '0');

            return `${pad(d.getDate())}.${pad(d.getMonth() + 1)}.${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
        },

        short_date(timestamp){
            const d = new Date(timestamp * 1000);

            const pad = (num) => String(num).padStart(2, '0');

            return `${pad(d.getDate())}.${pad(d.getMonth() + 1)}.${d.getFullYear()}`;
        },

        restoreHistory(record){
            this.applyData({
                send_post: record.send_post,
                send_user: record.send_user,
                accept_post: record.accept_post,
                accept_user: record.accept_user,
                items: record.items || [],
                is_date: record.is_date,
                is_kurch: record.is_kurch,
                kurch_text: record.kurch_text,
                tmc_type: record.tmc_type
            });

            this.editing_draft_id = null;
            window.scrollTo({ top: 0, behavior: 'smooth' });
        },

        downloadHistory(record){
            window.location.href = API_URL + "/generator/download?file_name=" + record.file_name;
        },

        previewHistory(record){
            if (this.preview_url) {
                URL.revokeObjectURL(this.preview_url);
                this.preview_url = null;
            }

            this.preview_modal = true;
            this.preview_loading = true;

            axios.get(API_URL + "/generator/preview", {
                params: {
                    file_name: record.file_name,
                    history_id: record.id
                },
                responseType: 'blob'
            }).then((response) => {
                this.preview_url = URL.createObjectURL(new Blob([response.data], { type: 'text/html' }));
            }).catch((error) => {
                console.log(error);
                this.preview_url = null;
                alert('Не удалось загрузить файл предпросмотра');
            }).finally(() => {
                this.preview_loading = false;
            });
        },

        closePreview(){
            this.preview_modal = false;

            if (this.preview_url) {
                URL.revokeObjectURL(this.preview_url);
                this.preview_url = null;
            }
        },

        deleteHistory(record){
            if (!confirm('Удалить запись из истории? Скачанный ранее файл останется у вас.')) {
                return;
            }

            axios.delete(API_URL + "/history/" + record.id).then(() => {
                this.loadHistory();
            }).catch((error) => {
                console.log(error);
            });
        }
    }
}

</script>


<style scoped>

.generator{
    width: 100%;
    min-height: 100vh;

    display: flex;
    flex-direction: column;
}

/* --- Раскладка --- */

.gen-layout{
    display: grid;
    grid-template-columns: minmax(0, 1fr);

    align-items: start;
}

/* --- Шапки карточек с действиями --- */

.work-card-header{
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
}

.work-card-header-actions{
    display: flex;
    align-items: center;
    gap: 4px;
}

.icon-btn{
    position: relative;

    display: inline-flex;
    align-items: center;
    justify-content: center;

    width: 30px;
    height: 30px;

    background: transparent;
    border: none;
    border-radius: 8px;
    color: var(--muted-foreground);

    cursor: pointer;

    transition: background-color 0.15s ease, color 0.15s ease;
}

.icon-btn:hover{
    background: var(--muted);
    color: var(--foreground);
}

.icon-btn-icon{
    width: 16px;
    height: 16px;
}

.icon-btn-count{
    position: absolute;
    top: -4px;
    right: -6px;

    display: inline-flex;
    align-items: center;
    justify-content: center;

    min-width: 15px;
    height: 15px;
    padding: 0 4px;

    background: var(--primary);
    color: var(--primary-foreground);
    border-radius: 999px;

    font-size: 10px;
    font-weight: 600;
}

/* --- Формы --- */

.grid-2--form{
    grid-template-columns: repeat(2, minmax(0, 1fr));
    row-gap: 22px;
}

.grid-2--form .field{
    margin-right: 0;
}

.kurch-input{
    margin-top: 16px;
}

.params-row{
    display: flex;
    flex-wrap: wrap;
    align-items: flex-end;
    justify-content: space-between;
    gap: 16px;

    margin-top: 4px;
}

.select-block{
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.select-label{
    display: inline-flex;
    align-items: center;
    gap: 6px;

    font-size: 13px;
    font-weight: 500;
    color: var(--muted-foreground);
}

.select-label-icon{
    width: 15px;
    height: 15px;
}

.select-input{
    min-width: 200px;
    height: 38px;
    padding: 0 10px;

    font-family: inherit;
    font-size: 14px;
    color: var(--foreground);

    background: var(--card);
    border: 1px solid var(--border);
    border-radius: 8px;
    outline: none;

    cursor: pointer;

    transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.select-input:hover{
    border-color: var(--border-hover);
}

.select-input:focus{
    border-color: var(--input-border-focus);
    box-shadow: 0 0 0 3px var(--ring);
}

.toggles{
    display: flex;
    flex-wrap: wrap;
    gap: 20px;

    padding-bottom: 9px;
}

.kurch-input{
    margin-top: 12px;

    max-width: 340px;
}

.field-hint{
    margin-top: 8px;

    font-size: 12px;
    color: var(--muted-foreground);
}

/* --- Информационный баннер --- */

.banner{
    display: flex;
    align-items: center;
    gap: 8px;

    margin-top: 12px;
    padding: 10px 12px;

    border-radius: 8px;
}

.banner--info{
    background: var(--muted);
    border: 1px solid var(--border);
}

.banner-icon{
    width: 14px;
    height: 14px;

    color: var(--muted-foreground);

    flex-shrink: 0;
}

.banner-text{
    font-size: 13px;
    color: var(--foreground);
}

/* --- Добавление позиции --- */

.add-row{
    display: flex;
    flex-wrap: wrap;
    align-items: flex-end;
    gap: 10px;

    margin-top: 20px;
    padding-top: 20px;
    padding-bottom: 20px;

    border-top: 1px solid var(--border);
}


/* --- Таблицы --- */

.table-scroll{
    overflow-x: auto;
}

/* Таблица ТМЦ: вертикальный скролл с закреплённой шапкой */
.table-scroll--items{
    max-height: 440px;

    overflow-x: auto;
    overflow-y: auto;
}

.table-scroll--items thead th{
    position: sticky;
    top: 0;
    z-index: 1;
}

.table{
    width: 100%;
    border-collapse: collapse;
    font-size: 14px;
}

.table th{
    padding: 10px 12px;

    text-align: left;
    font-size: 12px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    white-space: nowrap;

    color: var(--muted-foreground);
    background: var(--muted);
    border-bottom: 1px solid var(--border);
}

.table td{
    padding: 6px 8px;

    border-bottom: 1px solid var(--border);
    vertical-align: middle;
}

.table tbody tr:last-child td{
    border-bottom: none;
}

.table tbody tr:hover{
    background: var(--background);
}

.th-num,
.td-num{
    width: 48px;
    text-align: center;
}

.td-num{
    font-size: 13px;
    color: var(--muted-foreground);
}

.td-muted{
    color: var(--muted-foreground);
}

.item_input{
    width: 100%;
    min-width: 90px;
    padding: 6px 8px;

    font-family: inherit;
    font-size: 14px;
    color: var(--foreground);

    background: var(--card);
    border: 1px solid transparent;
    border-radius: 6px;
    outline: none;

    transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.item_input:hover{
    border-color: var(--border-hover);
}

.item_input:focus{
    border-color: var(--input-border-focus);
    box-shadow: 0 0 0 3px var(--ring);
}

textarea.item_input{
    resize: vertical;
    min-height: 34px;
}

.item_input--num{
    min-width: 64px;
    max-width: 84px;
}

.serial-row{
    display: flex;
    align-items: center;
    gap: 4px;

    padding: 2px 0;
}

.row-actions{
    display: flex;
    align-items: center;
    gap: 2px;
}

.row-btn{
    display: inline-flex;
    align-items: center;
    justify-content: center;

    width: 28px;
    height: 28px;

    background: transparent;
    border: none;
    border-radius: 6px;
    color: var(--muted-foreground);

    cursor: pointer;

    transition: background-color 0.15s ease, color 0.15s ease;
}

.row-btn:hover{
    background: var(--muted);
    color: var(--foreground);
}

.row-btn--danger:hover{
    background: var(--destructive-soft);
    color: var(--destructive);
}

.row-btn-icon{
    width: 15px;
    height: 15px;
}

/* --- Бейджи --- */

.badge{
    display: inline-flex;
    align-items: center;

    padding: 2px 8px;

    background: var(--muted);
    border: 1px solid var(--border);
    border-radius: 999px;

    font-size: 12px;
    color: var(--muted-foreground);
}

.badge--soft{
    padding: 1px 8px;
}

.badge--outline{
    background: transparent;
}

.badge--phone{
    background: var(--primary);
    border-color: var(--primary);
    color: var(--primary-foreground);
}

/* --- Подвал карточки генерации --- */

.gen-actions{
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;

    flex-wrap: wrap;
}

.gen-actions-left,
.gen-actions-right{
    display: flex;
    align-items: center;
    gap: 8px;
}

.gen-meta{
    display: inline-flex;
    align-items: center;
    gap: 6px;

    font-size: 13px;
    color: var(--muted-foreground);
}

.gen-meta-icon{
    width: 14px;
    height: 14px;
}

/* --- История --- */

.history-footer{
    display: flex;
    justify-content: flex-end;

    margin-top: 14px;
}

/* --- Список черновиков (модалка) --- */

.side-list{
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.side-item{
    display: flex;
    align-items: center;
    gap: 10px;

    padding: 8px;

    border-radius: 8px;

    transition: background-color 0.15s ease;
}

.side-item:hover{
    background: var(--muted);
}

.side-item-icon{
    width: 16px;
    height: 16px;

    color: var(--muted-foreground);

    flex-shrink: 0;
}

.side-item-body{
    flex: 1;

    min-width: 0;
}

.side-item-title{
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    font-size: 13px;
    font-weight: 500;
}

.side-item-sub{
    margin-top: 1px;

    font-size: 12px;
    color: var(--muted-foreground);
}

.side-item-actions{
    display: flex;
    align-items: center;
    gap: 2px;
}

/* --- Модалка сохранения --- */

.draft-name-row{
    margin-bottom: 10px;
}

.modal-hint{
    font-size: 12px;
    color: var(--muted-foreground);
}

.draft-modal-actions{
    justify-content: flex-end;

    margin-top: 18px;
}

/* --- Предпросмотр DOC --- */

.preview-frame{
    width: 100%;
    height: 70vh;

    border: 1px solid var(--border);
    border-radius: 8px;

    background: var(--card);
}

.preview-doc{
    max-width: 740px;

    margin: 0 auto;
    padding: 24px;

    font-family: "Times New Roman", Times, serif;
    font-size: 15px;
    line-height: 1.4;

    color: var(--foreground);
}

.preview-doc table{
    width: 100%;

    border-collapse: collapse;
}

.preview-doc th,
.preview-doc td{
    border: 1px solid var(--border-hover);
    padding: 4px 8px;
}

/* --- Адаптив --- */

@media (max-width: 960px){
    .gen-layout{
        grid-template-columns: 1fr;
    }

    .grid-2--form{
        grid-template-columns: 1fr;
    }
}

</style>
